var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebflow = function SvgWebflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1080 1080"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#146EF5",
    d: "M0 0h1080v1080H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m898.312 337.5-214.845 420h-201.8l89.912-174.066h-4.034C493.368 679.726 382.694 743.115 225 757.5V585.843s100.88-5.959 160.185-68.309H225V337.503h180.031v148.073l4.041-.017 73.567-148.056h136.152v147.134l4.041-.006L699.159 337.5z",
    clipRule: "evenodd"
  })));
};
export default SvgWebflow;